import { forwardRef, useContext } from 'react'
import styled, { css } from 'styled-components'
import { t } from 'ttag'
import { Heading } from 'react-bootstrap/lib/Media'

import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { Switch as SwitchComponent } from '@h2/components/inputs/switch'
import { Skeleton } from '@h2/components/loading/skeleton'
import { PG, SDB, SDB50S, SDB50T, PG50S, PG50T, SLB } from '@h2/components/colors'
import { features } from '@h2/components/media'
import { museoFont } from '@h2/components/mixins'
import {Globals} from '@h2/globals'

import { Profile } from './profile'

import { Panel } from '../panel'
import { VIEW_MODE_MANAGEMENT, VIEW_MODE_BASIC } from '../../constants'

const MuseoHeading = styled(Heading)`
  ${museoFont}
  font-weight: 900;

  > span {
    font-weight: 500;
  }
`
const fixed = css`
  position: fixed;
  width: 100%;
  z-index: 1000;

  @media (${features.minWidth.laptop}) {
    display: none;
  }
`
const PanelWrap = styled(Panel)`
  ${fixed};
`
const FlexWrap = styled(Flex)`
  ${fixed};
`
const BoxSwitch = styled(Box)`
  label {
    > span {
      color: white;
      margin: 0;
      font-size: 13px;
    }
  }

  > h4 {
    color: white;
    font-size: 20px;
    margin: 0;
  }
`
const Switch = styled(SwitchComponent)`
  &.MuiSwitch-root:not(.MuiSwitch-sizeSmall) {
    .MuiSwitch-switchBase {
      &.Mui-checked {
        color: ${PG50S};

        & + .MuiSwitch-track {
          background-color: ${PG50T};
          opacity: 0.8;
        }
      }

      &:not(.Mui-checked) {
        color: ${SDB50S};

        & + .MuiSwitch-track {
          background-color: ${SDB50T};
          opacity: 0.8;
        }
      }
    }
  }
`
const colors = { [VIEW_MODE_BASIC]: PG, [VIEW_MODE_MANAGEMENT]: SDB }
const ViewSwitcherProfile = forwardRef(function ViewSwitcherProfile(props, ref) {
  const { isEarlyLearnerMode, viewMode, handleOnViewChange } =
    useContext(Globals)


  if (!viewMode) {
    return null
  }

  if (viewMode === 'loading') {
    return (
      <FlexWrap>
        <Skeleton width="100%" height="38px" />
      </FlexWrap>
    )
  }

  return (
    <PanelWrap ref={ref} color={!isEarlyLearnerMode ? colors[viewMode] : SLB}>
      <Flex alignItems="center" justifyContent="space-between">
        <BoxSwitch>
          {!isEarlyLearnerMode ? (
            <Switch
              offColor={SDB}
              labelPosition="both"
              label={[t`Navigator Mode`, t`Explorer Mode`]}
              isOn={viewMode === VIEW_MODE_BASIC}
              onChange={handleOnViewChange}
            />
          ) : (
            <MuseoHeading>Early Learner Mode</MuseoHeading>
          )}
        </BoxSwitch>
        <Box>
          <Profile />
        </Box>
      </Flex>
    </PanelWrap>
  )
})

export { ViewSwitcherProfile }
